import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import firebase from 'firebase/app';

@Injectable({
  providedIn: 'root'
})
export class PagoService {

  constructor(private firestore: AngularFirestore) { }

  public getPaymentMethodsCollection(): any {
    return this.firestore.collection('payment_methods').valueChanges({ idField: 'id' });
  }
  public getCountReceipts(): any {
    return this.firestore.collection('receipts-invoices').get();
  }
  public insertarRecibo(alumno, tutor, estado = null, authorisationCode = null): any {
    let emissionDate : any;
    let paymentDate:any;
    if(authorisationCode) {
      emissionDate = new Date();
      paymentDate = new Date();
    }
    return this.firestore.collection('receipts-invoices').doc().set({
      appCreacion: 'nuevapantalla',
      titularPayment: tutor?.titularPayment || '',
      documentTitular: tutor?.documentTitular || '',
      numberDNITitular: tutor?.numberDNITitular || '',
      addressTitular: tutor?.addressTitular || '',
      zipTitular: tutor?.zipTitular || '',
      municipalityTitular: tutor?.municipalityTitular || '',
      cityTitular : tutor?.cityTitular || '',
      countryTitular : tutor?.countryTitular || '',
      swiftBicTitular : tutor?.swiftBicTitular || '',
      IBAN: tutor?.IBAN || '',
      paymentMethod: firebase.firestore().doc(`/payment_methods/${tutor?.paymentMethod || ''}`),
      dateTitular : tutor?.dateTitular || '',
      accountant : 'recibo',
      billableConcepts : alumno?.billable || [],
      emissionDate : {
        day : authorisationCode ? emissionDate.getDate() : tutor?.dateTitular.getDate(),
        month : authorisationCode ? emissionDate.getMonth() : tutor?.dateTitular.getMonth(),
        year : authorisationCode ? emissionDate.getFullYear() : tutor?.dateTitular.getFullYear()
      },
      fechaPago : authorisationCode ? paymentDate : tutor.dateTitular,
      idBillableConcepts : alumno.idBillableConcepts,
      code : alumno?.codeLastCourse || '',
      idCourse : firebase.firestore.FieldValue.arrayUnion(firebase.firestore().doc(`/courses/${alumno?.idLastCourse}`)),
      idTransation : authorisationCode? authorisationCode: '',
      infoEmail : 'pendiente de establecer',
      mounth :authorisationCode ? paymentDate.getMonth() : tutor?.dateTitular.getMonth(),
      numberReceipts : alumno?.numeroRecibo + '/' + alumno?.nameSerie,
      observations : '',
      paymentDate : {
        day : authorisationCode ? paymentDate.getDate() : tutor?.dateTitular.getDate(),
        month : authorisationCode ? paymentDate.getMonth() : tutor?.dateTitular.getMonth(),
        year : authorisationCode ? paymentDate.getFullYear() : tutor?.dateTitular.getFullYear()
      },
      serie : firebase.firestore().doc(`/series/${alumno?.idLastSerie}`),
      center : firebase.firestore().doc(`/centers/${alumno?.idLastCenter}`),
      state : estado ? estado : 'pendiente',
      student : firebase.firestore().doc(`/users/${alumno?.id}`),
      total : alumno.valorTotalAPagar,
      tutor : firebase.firestore().doc(`/users/${tutor?.id}`),
      year : authorisationCode ? paymentDate.getFullYear() : tutor?.dateTitular.getFullYear(),
      redSysPayment: authorisationCode? 'success': ''
    });
  }
}
